// store/modules/threadconvo.js
import convoService from "../../services/convoService.js";
import EventBus from "@/eventBus";
import { ALERT } from "../../constants/alert.js";
import store from "../index.js";
function cleanClone(obj) {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (e) {
    return obj;
  }
}
function initialThreadConvoState() {
  return {
    convo: {},
    allthreadconvos: [],
    loading: false,
    createthreaddata: {},
    showconvorightpanel: false,
    filterParentMessageId: null,
    threadMessages: {},
  };
}
export const modulethreadconvo = {
  namespaced: true,
  state: initialThreadConvoState(),

  getters: {
 
  convo(state) {
    return state.convo;
  },

  // Return message array for a given convoId (internal thread)
  // Normalizes key to string so lookups are consistent.
  getThreadMessages: (state) => (convoId) => {
    if (convoId === null || convoId === undefined) return [];
    const key = String(convoId);
    return state.threadMessages[key] ? state.threadMessages[key].slice() : [];
  },
    showconvorightpanel(state) {
      return state.showconvorightpanel;
    },

    allthreadconvos(state) {
      return state.allthreadconvos;
    },

    getSingleThread: (state) => (threadId) => {
      if (!threadId) return null;
      const list = Array.isArray(state.allthreadconvos)
        ? state.allthreadconvos
        : Object.values(state.allthreadconvos || {});
      const threadLink = list.find((item) => {
        return (
          item.convo_thread_id === threadId ||
          item.convo_thread?.convo_id === threadId
        );
      });
      if (!threadLink) return null;
      const thread = threadLink.convo_thread || {};
      const parentMessage = threadLink.convo_message || {};
      return {
        convo_id: thread.convo_id,
        convo_name: thread.convo_name,
        system_process: thread.system_process,
        convo_reminders: thread.convo_reminders || [],
        parent_message: {
          convo_message_id: parentMessage.convo_message_id,
          message: parentMessage.message,
          date: parentMessage.date,
          attachments: (parentMessage.convo_attachments || []).map((a) => ({
            media_id: a.media_id,
            file_name: a.medium?.file_name || null,
            content_type: a.medium?.content_type || null,
          })),
        },
      };
    },

simplifiedThreadConvos: (state, getters, rootState, rootGetters) => {
  const userId = rootGetters.userId;

  if (!Array.isArray(state.allthreadconvos)) return [];

  let result = state.allthreadconvos.map((threadLink, index) => {
    const thread = threadLink.convo_thread || {};
    const parentMessage = threadLink.convo_message || {};
    const participants = thread.convo_participants || [];
    const isParticipant = participants.some((p) => p.user_id === userId);

    const allReminders = thread.convo_reminders || [];
    const myReminders =
      thread.userReminder || allReminders.filter(r => r.reminder_for_who === userId);

    let reminderStatus = null;
    if (myReminders.length > 0) {
      reminderStatus = "green";
    } else if (allReminders.length > 0) {
      reminderStatus = "grey";
    }

    return {
      index,
      convo_id: thread.convo_id,
      convo_name: thread.convo_name,
      highlight: !isParticipant,
      parent_message: parentMessage,
      system_process: thread.system_process,
      convo_message_id: threadLink.convo_message_id,
      convo_reminders: allReminders,
      userReminder: myReminders,
      reminderStatus,
      userMentioned: thread.userMentioned ?? 0,
    };
  });

  // Process-level filter
  result = result.filter((t) => {
    const pass = t.system_process === "thread_internal";
    return pass;
  });


  // Parent message filter
  if (state.filterParentMessageId) {
    result = result.filter((t) => {
      const matched =
        t.convo_message_id == state.filterParentMessageId ||
        t.parent_message?.convo_message_id == state.filterParentMessageId;

      return matched;
    });


  }

  return result;
},

isfilter(state){
 return state.filterParentMessageId;
},

    getParticipantsByConvoId: (state) => (convoId) => {
      if (!convoId) return [];
      const thread = state.allthreadconvos.find(
        (t) => t.convo_thread?.convo_id === convoId
      );
      return thread?.convo_thread?.convo_participants || [];
    },

    isLoading(state) {
      return state.loading;
    },

    getcreatethreaddata(state) {
      return state.createthreaddata;
    },
  },

  mutations: {
    CLEAR_THREAD_MESSAGES(state, convoId) {
  const key = String(convoId);
    if (state.threadMessages[key]) {
    delete state.threadMessages[key];
  }
},
    RESET_THREADCONVO_STATE(state) {
      Object.assign(state, initialThreadConvoState());
    },
ADD_THREAD_REMINDER(state, payload) {
  const thread = state.allthreadconvos.find(
    (t) => t.convo_thread?.convo_id === payload.convo_id
  );
  if (!thread) return;

  if (!Array.isArray(thread.convo_thread.convo_reminders)) {
    thread.convo_thread.convo_reminders = [];
  }

  // avoid duplicates
  const exists = thread.convo_thread.convo_reminders.some(
    (r) => r.reminder_id === payload.reminder?.reminder_id
  );

  if (!exists) {
    thread.convo_thread.convo_reminders.push(payload.reminder);
  }
},
REMOVE_THREAD_CONVO(state, convoId) {
  const id = Number(convoId);
  const key = String(id);

  state.allthreadconvos = state.allthreadconvos.filter(thread => {
    const threadId =
      thread.convo_thread?.convo_id ??
      thread.convo_thread_id ??
      null;
    return Number(threadId) !== id;
  });

  if (state.threadMessages[key]) {
    delete state.threadMessages[key];
  }

  if (state.convo?.convo_id === id) {
    state.convo = {};
  }
},

    // Keep SET_THREAD_MESSAGES to replace the message array for a convo
SET_THREAD_MESSAGES(state, { convoId, messages }) {

  const key = String(convoId);


  const normalized = (Array.isArray(messages) ? messages : []).map(m => cleanClone({
    convo_message_id: m.convo_message_id ?? m.id ?? `tmp-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    convo_id: m.convo_id ?? Number(convoId),
    message: m.message ?? "",
    convo_attachments: m.convo_attachments ?? m.attachments ?? [],
    who_sent: m.who_sent ?? m.user_id ?? null,
    date: m.date ?? null,
    ref: m.ref ?? null,
    convo_mentions: Array.isArray(m.convo_mentions) ? m.convo_mentions : [],
    message_note: m.message_note ?? null
  }));

  state.threadMessages = {
    ...state.threadMessages,
    [key]: normalized
  };
},

  // Push a message into the stored message list for a convo
ADD_THREAD_MESSAGE(state, payload) {

  console.log("ADD_THREAD_MESSAGE raw payload:", cleanClone(payload));

  const convoId =
    payload.convoId ??
    payload.convo_id ??
    payload.convo?.convo_id;

  if (!convoId) {
    console.warn("❗ ADD_THREAD_MESSAGE called without convoId");
    return;
  }

  const key = String(convoId);

  // ensure array exists
  if (!state.threadMessages[key]) {
    state.threadMessages = { ...state.threadMessages, [key]: [] };
  }

  const raw = payload.message ?? payload;

  const message = cleanClone({
    convo_message_id: raw.convo_message_id ?? raw.id ?? `tmp-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    convo_id: Number(convoId),
    message: raw.message ?? raw.text ?? "",
    convo_attachments: raw.convo_attachments ?? raw.attachments ?? [],
    who_sent: raw.who_sent ?? raw.user_id ?? null,
    date: raw.date ?? new Date().toISOString(),
    ref: raw.ref ?? null,
    convo_mentions: Array.isArray(raw.convo_mentions) ? raw.convo_mentions : [],
    message_note: raw.message_note ?? null,
    system_process: "thread_internal"
  });


  const existingIndex = state.threadMessages[key].findIndex(
    m => m.convo_message_id === message.convo_message_id
  );

  if (existingIndex === -1) {
    state.threadMessages[key].push(message);
  } else {
    state.threadMessages[key].splice(existingIndex, 1, message);
  }

},

    SET_LOADING(state, payload) {
      state.loading = payload;
    },

    SHOWCONVORIGHTPANEL(state, value) {
      state.showconvorightpanel = value;
    },

    // Keep the original ADD_CONVO implementation — you rely on this elsewhere
  ADD_CONVO(state, convo) {

  // Normalise a thread-link. Important: use backend-provided ids.
  const normalized = {
    convo_thread_id: convo.convo_thread_id ?? convo.convo_id ?? null,
    convo_thread: convo.convo_thread ?? convo.convo ?? { convo_id: convo.convo_id },
    convo_message: convo.convo_message ?? convo.parent_message ?? convo.convo_messages?.[0] ?? {},
  };

  // avoid duplicates by convo_thread_id or convo_thread.convo_id
  const existingIdx = state.allthreadconvos.findIndex(
    t =>
      (t.convo_thread_id &&
        normalized.convo_thread_id &&
        t.convo_thread_id === normalized.convo_thread_id) ||
      (t.convo_thread?.convo_id &&
        normalized.convo_thread?.convo_id &&
        t.convo_thread.convo_id === normalized.convo_thread.convo_id)
  );

  if (existingIdx !== -1) {
    state.allthreadconvos.splice(existingIdx, 1, {
      ...state.allthreadconvos[existingIdx],
      ...normalized,
    });
  } else {
    console.log("inserting new thread convo at top");
    state.allthreadconvos.unshift(normalized);
  }

},

    // This mutation was in your original file — keep it
    PARENTTHREADDATA(state, value) {
      
      state.createthreaddata = value;
    },

    SET_ALL_THREAD_CONVOS(state, convos) {
      state.allthreadconvos = Array.isArray(convos) ? convos : Object.values(convos || {});
    },

    SET_CONVO(state, convo) {
      state.convo = convo;
    },

    SET_THREAD_FILTER(state, messageId) {
      state.filterParentMessageId = messageId;
    },
UPDATE_THREAD_REMINDER(state, payload) {
  const thread = state.allthreadconvos.find(
    t => t.convo_thread?.convo_id === payload.convo_id
  );
  if (!thread) return;

  const incoming = payload.reminder || payload;
  let reminders = thread.convo_thread.convo_reminders || [];

  const index = reminders.findIndex(
    r => r.reminder_for_who === incoming.reminder_for_who
  );

  if (index !== -1) {
    reminders[index] = { ...reminders[index], ...incoming };
  } else {
    reminders.push(incoming);
  }

  thread.convo_thread.convo_reminders = reminders;
},

COMPLETE_THREAD_MENTION(state, payload) {
  const convoId = payload.convo_id;
  const msgList = state.threadMessages[String(convoId)];
  if (!msgList) return;

  const msg = msgList.find(m => m.convo_message_id === payload.convo_message_id);
  if (!msg || !Array.isArray(msg.convo_mentions)) return;

  msg.convo_mentions = msg.convo_mentions.map(m => {
    if (m.user_id === payload.user_id) {
      return { ...m, completed: true };
    }
    return m;
  });
},

ADD_THREAD_PARTICIPANT(state, payload) {
  const thread = state.allthreadconvos.find(
    t => t.convo_thread?.convo_id === payload.convo_id
  );
  if (!thread) return;

  const participants = thread.convo_thread.convo_participants || [];

  const exists = participants.some(
    p => p.user_id === payload.participant.user_id
  );

  if (!exists) {
    participants.push(payload.participant);
  }

  thread.convo_thread.convo_participants = participants;
}


  },

  actions: {
    async fetchThreadConvos({ commit, getters, rootGetters }) {
      commit("SET_LOADING", true);
      try {
        const claim = rootGetters["osclaims/claim"];
        const convoId = claim?.DSSClaimsID;
        const response = await convoService.getThreadConvos(convoId);
        const convoList = Array.isArray(response.data?.data) ? response.data.data : [];
        commit("SET_ALL_THREAD_CONVOS", convoList);
      } catch (error) {
        console.error("fetchThreadConvos error:", error);
        commit("SET_ALL_THREAD_CONVOS", []);
        EventBus.$emit(ALERT, {
          type: "error",
          message: "Failed to load conversations.",
        });
      } finally {
        commit("SET_LOADING", false);
      }
    },

    //Load messages for a convo and SET_THREAD_MESSAGES

async loadThreadMessages({ commit, state }, convoId) {
  if (!convoId) return [];

  const key = String(convoId);

  // Always fetch fresh from backend — bypasses the getInternalMessages cache
  // so a second open of the same thread sees new WS messages.
  let raw = [];
  try {
    const response = await convoService.getInternalConvoMessages(convoId);
    raw = Array.isArray(response.data) ? response.data : [];
  } catch (e) {
    console.error("[loadThreadMessages] fetch failed:", e);
  }

  //  Normalize
  const cleaned = raw
    .filter(m => {
      const text = m.message && String(m.message).trim() !== "";
      const att = (m.convo_attachments?.length || m.attachments?.length);
      return text || att;
    })
    .map(m => cleanClone({
      convo_message_id: m.convo_message_id ?? m.id ?? `tmp-${Date.now()}`,
      message: m.message ?? "",
      convo_mentions: Array.isArray(m.convo_mentions) ? m.convo_mentions : [],
      convo_attachments: m.convo_attachments ?? m.attachments ?? [],
      who_sent: m.who_sent,
      date: m.date,
      convo_id: m.convo_id,
      ref: m.ref ?? null
    }));

  //  Sort
  cleaned.sort((a, b) => new Date(a.date) - new Date(b.date));

  //  Save CLEANED messages (no merge)
  commit("SET_THREAD_MESSAGES", { convoId: key, messages: cleaned });

  return cleaned;
},

    async fetchConvo({ commit }, convoId) {
      commit("SET_LOADING", true);
      try {
        const response = await convoService.getById(convoId);
        commit("SET_CONVO", response.data);
      } catch (error) {
        EventBus.$emit(ALERT, {
          type: "error",
          message: `Failed to load conversation ${convoId}.`,
        });
      } finally {
        commit("SET_LOADING", false);
      }
    },

async createConvo({ commit, dispatch }, convoData) {
  try {
    const response = await convoService.createInternalConvo(convoData);

    const payload = response?.data ?? response;
    const created = payload?.data ?? payload;

    const possibleMessage =
      created.convo_message ||
      created.message ||
      created ||
      null;

    const convoId =
      created?.convo?.convo_id ||
      created?.convo_id ||
      created?.convo_thread_id ||
      convoData?.parent_convo_id ||
      null;

    if (possibleMessage && convoId) {
      const normalizedMessage = {
        convo_message_id: possibleMessage.convo_message_id || possibleMessage.id ||null,
        message:possibleMessage.message ||possibleMessage.text ||"",
        convo_id: Number(convoId),
        date:possibleMessage.date ||new Date().toISOString(),
        convo_attachments:possibleMessage.convo_attachments ||possibleMessage.attachments || [],
        who_sent:possibleMessage.who_sent ||possibleMessage.user_id ||null,
        convo_mentions: Array.isArray(possibleMessage.convo_mentions) ? possibleMessage.convo_mentions: [],
        message_note: possibleMessage.message_note ?? null,
        _raw: possibleMessage
      };

      commit("ADD_THREAD_MESSAGE", { convoId, message: normalizedMessage });

      commit("ADD_CONVO", {
        convo_thread_id: convoId,
        convo_thread: {
          convo_id: convoId,
          convo_name: created?.convo?.convo_name ?? null
        },
        convo_message: normalizedMessage
      });
    }

    // Refresh thread convos list 
    await dispatch("fetchThreadConvos");

    EventBus.$emit(ALERT, {
      type: "success",
      message: "thread Conversation created successfully!"
    });

    // return response
    return {convo_id: convoId,message: possibleMessage, raw: response.data ?? response};

  } catch (error) {
    console.error("createConvo error:", error);
    EventBus.$emit(ALERT, {
      type: "error",
      message: "Failed to create Thread conversation."
    });
    return null;
  }
},
  },
};